export const useAffiliate = defineStore('affiliate', () => {
    // Public props
    const isReferred = ref<boolean>(false)
    const referralId = ref<string|undefined>();
    const affiliate = ref<{
        id: string;
        name: string;
        first_name: string;
        last_name: string;
        token: string;
    } | undefined>()

    // Private prop
    const loaded = ref<boolean>(false);

    /**
     * Triggers the initialization of rewardful
     *
     * @param apiKey
     */
    const initialize = (apiKey: string|undefined) => {
        if (!apiKey) {
            console.error("AFFILIATE: No API key provided, NOT INITIALIZED")
            return
        }
        
        injectRewardfulHtml(apiKey)
    }

    // Private function
    /**
     * Hook for rewardful to call when ready
     */
    const rewardfulReady = () => {
        console.log("AFFILIATE: Loaded Called")

        isReferred.value = !!getRewardfulProp('referral')
        referralId.value = getRewardfulProp('referral');
        affiliate.value = getRewardfulProp('affiliate')

        loaded.value = true;
    }

    /**
     * Fetches a prop safely (even when rewardful is not loaded / initialized properly)
     *
     * @param prop
     */
    const getRewardfulProp = (prop: string) => {
        // Safe check, to avoid errors when rewardful is not loaded into the window yet...
        // This is a build, because rewardful does NOT have a npm package, they suck
        if (typeof window === 'undefined') return undefined;
        if (!('Rewardful' in window)) return undefined;

        const rewardful = (window as any).Rewardful;
        return rewardful?.[prop];
    }

    /**
     * Inject the HTML stuff for loading rewardful
     *
     * @param apiKey
     */
    const injectRewardfulHtml = (apiKey: string) => {
        if (document.getElementById('rewardful-script')) {
            console.error("AFFILIATE: Rewardful script already present, ABORTING INJECTION")
            return
        }

        // Yes, this is the correct way defined by RewardFul: https://developers.rewardful.com/javascript-api/overview
        const shittyInitBufferScript = document.createElement('script');
        shittyInitBufferScript.type = 'text/javascript';
        shittyInitBufferScript.text = `(function(w,r){w._rwq=r;w[r]=w[r]||function(){(w[r].q=w[r].q||[]).push(arguments)}})(window,'rewardful');`;
        document.body.appendChild(shittyInitBufferScript);

        // Add our hook into a rewardful hook array we defined before (how shitty can you make an integration?)
        // @ts-expect-error
        window.rewardful('ready', () => {
            console.log("AFFILIATE: Rewardful ready via shitscript");
            rewardfulReady();
        });

        const script = document.createElement('script');
        script.id = 'rewardful-script';
        script.src = 'https://r.wdfl.co/rw.js';
        script.async = true;
        script.setAttribute('data-rewardful', apiKey);

        document.body.appendChild(script);
    }

    return { referralId, isReferred, affiliate, initialize };
});